import React from 'react';
import PropTypes from 'prop-types';
import '../Skeleton/Skeleton.scss';

const SubpaneButton = React.memo( ({ btnText, subpaneDataId, setActiveSubpaneId, activeSubpaneId, setShowSubpaneNavBtns }) => {

  let activeClassName = activeSubpaneId === subpaneDataId ? 'subpaneButtons-nav__button subpaneButtons-nav__button--active' : 'subpaneButtons-nav__button';

  let windowWidth = window.innerWidth || 0;

  const handleOnClick = (subpaneDataId) => {
    if(windowWidth < 768) {
      setShowSubpaneNavBtns(false);
    }
    setActiveSubpaneId(subpaneDataId);
  }

  return (
    <button className={activeClassName} onClick={ () => handleOnClick(subpaneDataId) }>
      {btnText || <span className="skeleton skeleton--medium" style={{ display: 'inline-block', width: '120px', height: '18px' }} />}
    </button>
  );
} );

SubpaneButton.propTypes = {
  btnText: PropTypes.string,
  subpaneDataId: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ).isRequired,
  setActiveSubpaneId: PropTypes.func.isRequired,
  activeSubpaneId: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
  setShowSubpaneNavBtns: PropTypes.func.isRequired,
};

SubpaneButton.defaultProps = {
  activeSubpaneId: null,
  btnText: null,
};

export default SubpaneButton;